import React, { useCallback, useEffect, useState } from "react";
import { HeadingTitle } from "../ModalContainer";
import DataTable from "../../DataTable/DataTable";
import axios from "axios";
import { toast } from "react-toastify";
import NoData from "../../Pagination/NoData";
import { BASEURI } from "../../../Middleware/axiosInstance";

const ViewComment = (props) => {
  const { close } = props;
  //   const token = "1RNGF3QQ8SA";
  const baseDomain = BASEURI.split("/")[0] + "//" + BASEURI.split("/")[2];

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const fetchCadData = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${baseDomain}/ManufactureOrders/ajaxAddComment/${props.order_id}`
      );

      if (data.status === 1) {
        setData(data?.data?.records);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(data.msg);
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }, [props.order_id, baseDomain]);

  useEffect(() => {
    fetchCadData();
  }, [fetchCadData]);

  return (
    <>
      <HeadingTitle colorRed={false} title={props.title} closeModal={close} />
      <div
        style={{ maxHeight: "350px", overflow: "auto", position: "relative" }}
      >
        {data && data?.length > 0 ? (
          <DataTable
            header={["Comment", "Created On", "Images"]}
            viewcomment={data}
            isLoading={loading}
          />
        ) : (
          <div className="flex-container-row">
            <NoData />
          </div>
        )}
      </div>
    </>
  );
};

export default ViewComment;
